import { Box, Button, ClickAwayListener, Card, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

interface EditAgentProps {
  isOpen: boolean;
  onClose: () => void;
  agentData: any; // Add agentData prop
  onSubmit: (data: any) => void;
}

const EditAgent: React.FC<EditAgentProps> = ({ isOpen, onClose, agentData, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: agentData?.name || "", // Initialize with agentData.name
    description: agentData?.description || "", // Initialize with agentData.description
    "agent_type": "cloud",
  });
  const [touched, setTouched] = useState({ name: false, description: false });
  const [isEditDiscoveyCardOpen, setIsEditDiscoveryCardOpen] = useState(false);
  const alphaNumPattern = /^[a-zA-Z0-9 ]*$/;

  useEffect(() => {
    const handleEsc = (event: any) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  const isFormValid = () => {
    return (
      formData.name.trim().length >= 5 &&
      formData.name.trim().length <= 20 &&
      alphaNumPattern.test(formData.name) &&
      formData.description.trim().length >= 5 &&
      formData.description.trim().length <= 50 &&
      alphaNumPattern.test(formData.description)
    );
  };
  const handleSubmit = () => {
    const dataToSend = {
      name: formData.name,
      description: formData.description,
    };

    onSubmit(dataToSend);
    onClose();
  };

  const handleFormChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };
  const handleBlur = (field: string) => {
    setTouched({ ...touched, [field]: true }); // Mark the field as touched
  };

  if (!isOpen) return null;

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          pr: 2,
          pt: 2,
          height: "98vh",
          width: "350px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          zIndex: 1300,
        }}
      >
        <Card
          sx={{
            width: "100%",
            height: "97vh",
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            borderRadius: "12px",
            boxShadow: 3,
            position: "relative",
          }}
        >
          <div className="cloud-scan-header">
            <div className="header-left">
              <p className="header-title" style={{ fontSize: "18px", fontWeight: "bold" }}>Edit</p>
            </div>
            <IconButton
              onClick={onClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div>
            <div>
              <hr
                style={{
                  border: "none",
                  borderTop: "1px solid #E2E2F2",
                  margin: "16px 0",
                }}
              />
            </div>
            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleFormChange}
              onBlur={() => handleBlur("name")}
              fullWidth
              required
              margin="normal"
              inputProps={{ minLength: 5, maxLength: 20 }}
              error={
                touched.name &&
                (
                  formData.name.trim().length < 5 ||
                  formData.name.trim().length > 20 ||
                  !alphaNumPattern.test(formData.name)
                )
              }
              helperText={
                touched.name &&
                (
                  formData.name.trim().length < 5
                    ? "Name must be at least 5 characters."
                    : formData.name.trim().length > 20
                      ? "Maximum 20 characters allowed"
                      : !alphaNumPattern.test(formData.name)
                        ? "Special characters not allowed"
                        : ""
                )
              }
            />
            <TextField
              label="Description"
              name="description"
              value={formData.description}
              onChange={handleFormChange}
              onBlur={() => handleBlur("description")}
              fullWidth
              required
              margin="normal"
              inputProps={{ minLength: 5, maxLength: 50 }}
              error={
                touched.description &&
                (
                  formData.description.trim().length < 5 ||
                  formData.description.trim().length > 50 ||
                  !alphaNumPattern.test(formData.description)
                )
              }
              helperText={
                touched.description &&
                (
                  formData.description.trim().length < 5
                    ? "Description must be at least 5 characters."
                    : formData.description.trim().length > 50
                      ? "Maximum 50 characters allowed"
                      : !alphaNumPattern.test(formData.description)
                        ? "Special characters not allowed"
                        : ""
                )
              }
            />

          </div>
          <div style={{ flexGrow: 1 }}></div>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!isFormValid()}
            sx={{ width: "100%" }}
          >
            Submit
          </Button>
        </Card>
      </Box>
    </ClickAwayListener>
  );
};

export default EditAgent;